import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { Container } from 'containers/CourtManagerLegalProceedings/Provision/styled-components';
import InfoBloc from 'containers/CourtManagerLegalProceedings/Provision/infoBloc';
import { translate } from 'containers/services/translate';
import MoneyIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/money-icon';
import ClaimIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/claim-icon';
import ClockIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/clock-icon';
import messages from 'containers/CourtManagerLegalProceedings/Provision/messages';
import {
  getGlobalProvisionDetailInfo,
  getIntervenantDetailInfo,
  getProvisionInfo,
} from 'containers/CourtManagerLegalProceedings/Provision/utils';
import ArrowIcon from 'containers/CourtManagerLegalProceedings/Provision/assets/arrow-icon';
import { EMPTY_CLAIM } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import IntervenantProvision from 'containers/CourtManagerLegalProceedings/Provision/intervenantProvision';
import RiskTable from 'containers/CourtManagerLegalProceedings/Provision/riskTable';
import GlobalProvision from 'containers/CourtManagerLegalProceedings/Provision/globalProvision';
import { Listings } from 'containers/AppContainer/typings';
import { isNil } from 'lodash';

export interface ProvisionContainerProps {
  intl: IntlShape;
  listings: Listings;
  claimNumber: string;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  setIsDetail?: Function;
  requestValidateProvisionIntervenant?: Function;
  claimId: number;
  isConsultation: Boolean;
  requestCreateStakeHolder?: Function;
  lossDate: any;
  uploadedDocument: any;
  resetUploadDocumentStore: Function;
  uploadDocument: Function;
  requestCreateFeeNoteManager: Function;
}

export const ProvisionContainer: React.FC<ProvisionContainerProps> = ({
  claimNumber,
  requestSagisClaimInfo,
  listings,
  sagisClaim,
  ...props
}): JSX.Element => {
  const [currentRisk, setCurrentRisk] = useState<any>(null);
  const [updateCurrentRisk, setUpdateCurrentRisk] = useState(false);

  const handleGetRiskDetail = (risk: any) => () => {
    setCurrentRisk(risk);
    if (props.setIsDetail) props.setIsDetail(true);
  };
  const provisionInfo = getProvisionInfo(sagisClaim);
  const claim = sagisClaim ? sagisClaim : EMPTY_CLAIM;

  useEffect(() => {
    /* istanbul ignore next */
    !isNil(claimNumber) && requestSagisClaimInfo(claimNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimNumber]);
  useEffect(() => {
    const risk =
      provisionInfo.find(
        (item: any) => item.riskId === get(currentRisk, 'riskId'),
      ) || {};
    updateCurrentRisk && setCurrentRisk(risk);
  }, [updateCurrentRisk]);
  return (
    <Container id="provision-wrapper">
      {currentRisk && (
        <>
          <div className="navContainer">
            <div
              className="nav header"
              data-testid="global-provision"
              onClick={() => {
                setCurrentRisk(null);
                if (props.setIsDetail) props.setIsDetail(false);
              }}
            >
              {translate(messages.globalProvision, props)}{' '}
              <span style={{ marginLeft: '15px' }}>
                <ArrowIcon />
              </span>
            </div>
            <div className="nav subHeader">{currentRisk.riskName}</div>
          </div>
          <GlobalProvision
            provisions={getGlobalProvisionDetailInfo(currentRisk)}
            requestValidateProvisionIntervenant={
              props.requestValidateProvisionIntervenant
            }
            riskId={get(currentRisk, 'riskId')}
            riskName={get(currentRisk, 'riskName')}
            claimNumber={claimNumber}
            setCurrentRisk={setCurrentRisk}
            setUpdateCurrentRisk={setUpdateCurrentRisk}
            claimId={props.claimId}
            isConsultation={props.isConsultation}
          />
          {/* {currentRisk.riskNature === RISK_NATURE.CORPOREAL ? (
            <VictimProvision provisions={null} />
          ) : (
            <OpposingPartyProvision
              provisions={getOpposingPartyDetailInfo(currentRisk)}
            />
          )} */}
          <IntervenantProvision
            provisions={getIntervenantDetailInfo(
              currentRisk,
              get(currentRisk, 'riskId'),
              listings,
            )}
            requestValidateProvisionIntervenant={
              props.requestValidateProvisionIntervenant
            }
            riskId={get(currentRisk, 'riskId')}
            claimNumber={claimNumber}
            setCurrentRisk={setCurrentRisk}
            setUpdateCurrentRisk={setUpdateCurrentRisk}
            claimId={props.claimId}
            isConsultation={props.isConsultation}
            riskName={get(currentRisk, 'riskName')}
            listings={listings}
            lossDate={props.lossDate}
            requestCreateStakeHolder={props.requestCreateStakeHolder}
            uploadedDocument={props.uploadedDocument}
            resetUploadDocumentStore={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            requestCreateFeeNoteManager={props.requestCreateFeeNoteManager}
          />
        </>
      )}
      {!currentRisk && (
        <>
          <div className="provision-container">
            <InfoBloc
              title={translate(messages.ClaimNumber, props)}
              value={claimNumber}
            >
              <ClaimIcon />
            </InfoBloc>
            <InfoBloc
              title={translate(messages.ClaimStatus, props)}
              claimStatus={claim.status}
            >
              <ClockIcon />
            </InfoBloc>
            <InfoBloc
              title={translate(messages.CompanyCost, props)}
              value={claim.companyCost}
            >
              <MoneyIcon />
            </InfoBloc>
          </div>
          <RiskTable
            provisionInfo={provisionInfo}
            handleGetRiskDetail={handleGetRiskDetail}
          />
        </>
      )}
    </Container>
  );
};

export default injectIntl(ProvisionContainer);
